import React, { Component } from 'react';
import WithFooter from '../layout/WithFooter';
import WithBackButton from '../layout/WithBackButton';
import Rules from '../components/messages/Rules';
import Pixel, {PIXEL_ACTIONS} from '../components/utils/Pixel'

class RulesPage extends Component {
    render() {
        return (
            <WithFooter>
                <WithBackButton>
                    <Rules />
                </WithBackButton>
                <Pixel action={PIXEL_ACTIONS.VIEW_RULES} />
            </WithFooter>
        )
    }
};

export default RulesPage;
